import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { DefaultSpawner } from './default-spawner.js';

export class ModeAwareSpawner extends DefaultSpawner {
    static TypeName = 'mode-aware-spawner';
    static InheritProperties = true;

    //  protected override spawnNext(): Object3D {
    // GameObject obj = base.SpawnNext();
    // obj = Puzzle.GetPuzzle().Rules.FruitPreSpawn(obj);
    // return obj;
    //  }
}
